import { Controller } from "@hotwired/stimulus"

const COMPLETED_STORIES_KEY = 'completedStories'

export default class extends Controller {
  static values = {
    bookId: Number
  }

  connect() {
    this.applyReadingStatuses()
  }

  applyReadingStatuses() {
    const completed = this.getCompletedStoryIds()
    const items = this.element.querySelectorAll('[data-story-id]')

    items.forEach(item => {
      const storyId = item.dataset.storyId
      if (completed.has(storyId)) {
        const badge = item.querySelector('[data-reading-status-badge]')
        if (badge) {
          badge.textContent = '読了'
          badge.classList.remove('d-none')
        }

        const link = item.querySelector('[data-reading-status-link]')
        if (link) {
          link.classList.add('link-opacity-50')
        }
      }
    })
  }

  getCompletedStoryIds() {
    const stored = localStorage.getItem(COMPLETED_STORIES_KEY)
    const completed = stored ? JSON.parse(stored) : []
    const bookId = this.bookIdValue.toString()

    return new Set(
      completed
        .filter(key => key.startsWith(`${bookId}-`))
        .map(key => key.split('-')[1])
    )
  }
}
